import React from "react";

import { pickPercent } from "./utils";
import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import DivFormula from "./DivFormula";

const MarketShare = ({ teams, competitionMetrics }) => (
  <OnePanelChart
    title="Market Share"
    suffix="%"
    data={pickPercent(teams, competitionMetrics, "Market Share")}
    teams={teams}
  >
    <Text>
      Market Share represents the percentage of total sales that your business
      has captured within a market within a period of time. It is calculated by
      taking your business sales and dividing it by the total of all sales.
    </Text>
    <Text>
      For example, if Apple sold 36 smartphones in 2017 and there were a total
      of 100 smartphones sold in 2017, then Apple held 36% market share (i.e.
      36% = 36/100).
    </Text>
    <DivFormula
      name1="MARKET SHARE"
      name2="YOUR UNIT SALES"
      name3="TOTAL INDUSTRY SALES"
    />
  </OnePanelChart>
);

export default MarketShare;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketShare.js